// Teacher Settings — reuses student Settings

import Settings from '../student/Settings';
export default Settings;
